/**
 * @format
 * @Description: 消息事件状态机
 * @Autho: 方证
 * @Date: 2019/12/10
 */

import { action, observable, useStrict } from 'mobx';
import Serv from './MessageEventsServ';
import Utils from 'utils';
import { filter, get } from 'lodash';

const CDN_BASE = 'assets';
useStrict(true);
class MessageEventsMod {
  @observable
  editing = true;

  @observable
  eventId = '';

  @observable
  listVersion = 1;

  @observable
  showModal = false;

  @observable
  formData = {};

  @observable
  eventTypeData = [{ label: 'a', value: 1 }];

  @observable
  eventTypeEmum = {};

  @action
  updateStore(payload) {
    for (let i in payload) {
      this[i] = payload[i];
    }
  }

  getListBeforeRequest = data => {
    //console.log(45,data)
    let beginTime = get(data, ['time', '0', '_d']) ? Utils.timeFormat(get(data, ['time', '0', '_d'])) : '';
    let endTime = get(data, ['time', '1', '_d']) ? Utils.timeFormat(get(data, ['time', '1', '_d'])) : '';
    data.updateTimeBegin = beginTime || undefined;
    data.updateTimeEnd = endTime || undefined;
    data.triggerType = '1';
    delete data.time;
    for (let i in data) {
      data[i] = data[i] || undefined;
    }
    return data;
  };
  getListAfterRequest = data => {
    data.list = filter(data.list, item => {
      item.updateStatus = item.status == 1 ? 0 : 1;
      if (item.triggerType == 1) {
        return item;
      }
    });
    return data;
  };
  addEvent = data => {
    this.updateStore({ showModal: true, editing: false, formData: {} });
  };

  editEvent = data => {
    this.updateStore({ showModal: true, editing: true, formData: data });
  };

  @action getListEventType = async payload => {
    // 请求参数
    let params = payload;

    return await Serv.getListEventType(params);
  };
  saveFormBeforeRequest = data => {
    if (this.editing) {
      data.id = this.formData.id;
    }
    data.triggerType = 1;
    return data;
  };
}

// ES6单例写法
export default new MessageEventsMod();



// WEBPACK FOOTER //
// ./src/pages/MessageManage/MessageEvents/MessageEventsMod.js